module.exports = __webpack_public_path__ + "static/media/rugrats-viewer-border.f4d3b32e.png";